import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const QUERY = gql`
  query ConnectedAccountsRequests($workspaceId: ID!) {
    connectedAccounts(workspaceId: $workspaceId) {
      channel
      requests {
        id
        status
      }
    }
  }
`;

export const connectedAccountsRequests = (workspaceId) => {
  return apolloClient
    .query({
      query: QUERY,
      variables: {
        workspaceId,
      },
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => getSingleProp(data));
};
